import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    recognitionWallList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    recognitionWallDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const recognitionWallSlice = createSlice({
  name: 'recognitionWall',
  initialState,
  reducers: {
    getRecognitionWallList: (state, action) => {
        state.recognitionWallList.requesting = true;
        state.recognitionWallList.error = null;
        state.recognitionWallList.items = [];
        state.recognitionWallList.success = false;
        state.recognitionWallList.filters = action.payload;
    },
    getRecognitionWallListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.recognitionWallList.requesting = false;        
        state.recognitionWallList.items = data;
        state.recognitionWallList.success = true; 
        state.recognitionWallList.pagination.current_page = current_page;
        state.recognitionWallList.pagination.per_page = per_page;
        state.recognitionWallList.pagination.total = total;
    },
    getRecognitionWallListFail: (state, action) => {        
        state.recognitionWallList.requesting = false;
        state.recognitionWallList.error = action.payload;
    },
    getRecognitionWallDetails: (state) => {
        state.recognitionWallDetails.requesting = true;
        state.recognitionWallDetails.error = null;
        state.recognitionWallDetails.data = null;
        state.recognitionWallDetails.success = false; 
    },
    getRecognitionWallDetailsSuccess: (state, action) => {
        state.recognitionWallDetails.requesting = false;
        state.recognitionWallDetails.data = action.payload;
        state.recognitionWallDetails.success = true; 
    },
    getRecognitionWallDetailsFail: (state, action) => {        
        state.recognitionWallDetails.requesting = false;
        state.recognitionWallDetails.error = action.payload;
    },
    doRecognitionWallCreate: (state) => {
        state.recognitionWallDetails.requesting = true;
        state.recognitionWallDetails.error = null;
        state.recognitionWallDetails.data = null;
        state.recognitionWallDetails.success = false; 
    },
    doRecognitionWallUpdate: (state) => {
        state.recognitionWallDetails.requesting = true;
        state.recognitionWallDetails.error = null;
        state.recognitionWallDetails.data = null;
        state.recognitionWallDetails.success = false; 
    },
    doRecognitionWallDelete: (state) => {
        state.recognitionWallDetails.requesting = true;
        state.recognitionWallDetails.error = null;
        state.recognitionWallDetails.data = null;
        state.recognitionWallDetails.success = false; 
    },
  },
})

export const { 
    getRecognitionWallList, getRecognitionWallListSuccess, getRecognitionWallListFail,
    getRecognitionWallDetails, getRecognitionWallDetailsSuccess, getRecognitionWallDetailsFail,
    doRecognitionWallCreate, doRecognitionWallUpdate, doRecognitionWallDelete
} = recognitionWallSlice.actions

export default recognitionWallSlice.reducer